/**
 * @generated SignedSource<<f12107204bf44c86e8a03572518d21ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCategoryTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorsResultContainer_viewer">;
  readonly " $fragmentType": "SbSharedCategoryTabs_viewer";
};
export type SbSharedCategoryTabs_viewer$key = {
  readonly " $data"?: SbSharedCategoryTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCategoryTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCategoryTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCreatorsResultContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "062a4563923954c71e92d0b8ad2ea85a";

export default node;
